import * as types from "./mutations-type";
export default{
    [types.SET_MSG](state,payload){
        state.msg = payload
    },
    [types.SET_EDITAR](state,payload){
        state.editar = payload
    },
    [types.SET_LISTA](state,payload){
        state.lista = payload
    },
    [types.SET_ID](state,payload){
        state.id = payload
    },
    [types.SET_TRABALHADOR](state,payload){
        state.trabalhador = payload
    },
}